<template>
    <div class="order-receipt-edit-page" v-loading="loading">
        <el-page-header content="编辑收件建档" @back="$router.push('/orders/' + $route.params.id)" />

        <el-card shadow="never" class="order-receipt-edit-page__card">
            <el-form ref="receiptForm" :model="form" :rules="rules" label-width="120px">
                <el-divider content-position="left">公司信息</el-divider>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="公司名称" prop="company.name">
                            <el-input v-model.trim="form.company.name" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="统一信用代码" prop="company.credit_code">
                            <el-input v-model.trim="form.company.credit_code" maxlength="18" />
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="主体类型" prop="company.entity_type">
                            <el-radio-group v-model="form.company.entity_type">
                                <el-radio :label="1">公司</el-radio>
                                <el-radio :label="2">个体户</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="公司所属省份" prop="company.province">
                            <el-select v-model="form.company.province" class="full-width">
                                <el-option label="广东省" value="广东省" />
                                <el-option label="北京市" value="北京市" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="法人姓名" prop="company.legal_name">
                            <el-input v-model.trim="form.company.legal_name" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="法人身份证" prop="company.legal_id_no">
                            <el-input v-model.trim="form.company.legal_id_no" maxlength="18" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="法人手机号" prop="company.phone">
                            <el-input v-model.trim="form.company.phone" maxlength="11" />
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="税务情况" prop="order.tax_account_status">
                            <el-select v-model="form.order.tax_account_status" placeholder="请选择" class="full-width">
                                <el-option label="正常户" :value="1" />
                                <el-option label="非正常户" :value="2" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="工商情况" prop="order.biz_announcement_status">
                            <el-select v-model="form.order.biz_announcement_status" placeholder="请选择" class="full-width">
                                <el-option label="正常" :value="1" />
                                <el-option label="撤销" :value="2" />
                                <el-option label="吊销" :value="3" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="年报情况" prop="order.annual_report_stage">
                            <el-select v-model="form.order.annual_report_stage" placeholder="请选择" class="full-width">
                                <el-option label="正常" :value="1" />
                                <el-option label="逾期申报" :value="2" />
                                <el-option v-if="form.order.annual_report_stage === 3" label="已补报" :value="3" />
                                <el-option v-if="form.order.annual_report_stage === 4" label="已修复" :value="4" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="公示结束时间" prop="company.announcement_end_date">
                    <el-date-picker
                        v-model="form.company.announcement_end_date"
                        type="date"
                        value-format="yyyy-MM-dd"
                        class="full-width"
                    />
                </el-form-item>

                <el-divider content-position="left">订单设置</el-divider>

                <el-form-item label="是否开启外勤" prop="order.is_work_enabled">
                    <el-switch v-model="workSwitch" active-text="开启" inactive-text="关闭" />
                </el-form-item>

                <el-form-item>
                    <el-button @click="$router.push('/orders/' + $route.params.id)">取消</el-button>
                    <el-button type="primary" :loading="submitting" @click="handleSubmit">保存建档信息</el-button>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>

<script>
export default {
    name: 'OrderReceiptEdit',
    data() {
        return {
            loading: false,
            submitting: false,
            form: {
                company: {
                    name: '',
                    entity_type: 1,
                    credit_code: '',
                    legal_name: '',
                    legal_id_no: '',
                    phone: '',
                    province: '广东省',
                    announcement_end_date: ''
                },
                order: {
                    is_work_enabled: 0,
                    tax_account_status: 1,
                    biz_announcement_status: 1,
                    annual_report_stage: 1
                }
            },
            rules: {
                'company.name': [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
                'company.credit_code': [{ required: true, message: '请输入统一信用代码', trigger: 'blur' }],
                'company.legal_name': [{ required: true, message: '请输入法人姓名', trigger: 'blur' }],
                'company.legal_id_no': [{ required: true, message: '请输入法人身份证', trigger: 'blur' }],
                'company.phone': [{ required: true, message: '请输入法人手机号', trigger: 'blur' }],
                'company.province': [{ required: true, message: '请选择省份', trigger: 'change' }],
                'company.announcement_end_date': [{ required: true, message: '请选择公示结束时间', trigger: 'change' }],
                'order.tax_account_status': [{ required: true, message: '请选择税务情况', trigger: 'change' }],
                'order.biz_announcement_status': [{ required: true, message: '请选择工商情况', trigger: 'change' }],
                'order.annual_report_stage': [{ required: true, message: '请选择年报情况', trigger: 'change' }]
            }
        };
    },
    created() {
        this.fetchDetail();
    },
    computed: {
        workSwitch: {
            get() {
                return this.form.order.is_work_enabled === 1;
            },
            set(value) {
                this.form.order.is_work_enabled = value ? 1 : 0;
            }
        }
    },
    methods: {
        fetchDetail() {
            var _this = this;
            this.loading = true;

            window.axios.get('/orders/' + this.$route.params.id).then(function (response) {
                var data = response.data.data || {};
                var company = data.company || {};

                _this.form = {
                    company: {
                        name: company.name || '',
                        entity_type: company.entity_type || 1,
                        credit_code: company.credit_code || '',
                        legal_name: company.legal_name || '',
                        legal_id_no: company.legal_id_no || '',
                        phone: company.phone || '',
                        province: company.province || '广东省',
                        announcement_end_date: company.announcement_end_date || ''
                    },
                    order: {
                        is_work_enabled: data.is_work_enabled || 0,
                        tax_account_status: data.tax_account_status != null ? Number(data.tax_account_status) : 1,
                        biz_announcement_status: data.biz_announcement_status != null ? Number(data.biz_announcement_status) : 1,
                        annual_report_stage: data.annual_report_stage != null ? Number(data.annual_report_stage) : 1
                    }
                };
            }).finally(function () {
                _this.loading = false;
            });
        },
        handleSubmit() {
            var _this = this;

            this.$refs.receiptForm.validate(function (valid) {
                if (!valid) {
                    return false;
                }

                _this.submitting = true;

                window.axios.put('/orders/' + _this.$route.params.id + '/receipt', _this.form).then(function () {
                    _this.$message.success('建档信息更新成功');
                    _this.$router.replace('/orders/' + _this.$route.params.id);
                }).catch(function (error) {
                    var message = error && error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : '建档信息更新失败';
                    _this.$message.error(message);
                }).finally(function () {
                    _this.submitting = false;
                });
            });
        }
    }
};
</script>

<style scoped>
.order-receipt-edit-page {
    padding: 24px;
}

.order-receipt-edit-page__card {
    margin-top: 16px;
}

.full-width {
    width: 100%;
}

.order-receipt-edit-page /deep/ .el-form-item__label {
    color: #909399;
    font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/OrderReceiptEdit.vue